import { useLazyQuery } from '@apollo/client';
import moment from 'moment';
import { useRef } from 'react';

import { setCountryName } from '../../../countries/services/useFetchCountries';
import { Language } from '../../../languages/enums/language.enum';
import MasterEvent, { MasterEventQuerySingleInput } from '../../models/MasterEvent';
import { GET_MASTER_EVENT } from './query';

interface QueryData {
  masterEvent: MasterEvent;
}

interface QueryVariables extends MasterEventQuerySingleInput {}

/**
 * Fetch a specific master event
 */
function useFetchMasterEvent() {
  const isNotFound = useRef(false);
  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVariables>(
    GET_MASTER_EVENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  const formatData = (data?: QueryData): MasterEvent | undefined => {
    if (!data) {
      return undefined;
    }

    if (!data.masterEvent) {
      isNotFound.current = true;
      return undefined;
    }

    const setLocaleCountryName = setCountryName(Language.English);

    const { startAt, endAt, country, card } = data.masterEvent;
    return {
      ...data.masterEvent,
      country: country ? setLocaleCountryName(country) : undefined,
      startAt: moment(startAt).toDate(),
      endAt: moment(endAt).toDate(),
      // TODO Split -
      /*      card: {
        ...(card as CRMCard),
        country: card?.country ? setLocaleCountryName(card?.country) : undefined,
      },*/
    };
  };

  const fetchMasterEvent = async (masterEventId: string) => {
    const variables = {
      _id: masterEventId,
    };

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return formatData(response.data);
  };

  return {
    fetchMasterEvent,
    loading,
    error,
    isNotFound: isNotFound.current,
    masterEvent: formatData(data),
  };
}

export default useFetchMasterEvent;
